import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

// Polyfill Buffer for browser usage (webpack 5 removed automatic polyfills)
// Required by gray-matter/js-yaml when parsing frontmatter in the browser
import { Buffer } from 'buffer';
if (!window.Buffer) {
  window.Buffer = Buffer;
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
